/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatisticByStateList } from '../../models/statistic-by-state-list';

export interface StatisticsByState$Params {
}

export function statisticsByState(http: HttpClient, rootUrl: string, params?: StatisticsByState$Params, context?: HttpContext): Observable<StrictHttpResponse<StatisticByStateList>> {
  const rb = new RequestBuilder(rootUrl, statisticsByState.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StatisticByStateList>;
    })
  );
}

statisticsByState.PATH = '/custom/stations/statisticsByState';
